<template>
  <svg width="18"
       height="18"
       viewBox="0 0 18 18"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M16.7275 2.61414L17.3867 1.9198C17.7207 1.56824 17.7471 1.08484 17.4131 0.750857L17.1846 0.513552C16.8857 0.214724 16.3848 0.258669 16.0596 0.583865L15.374 1.25183L16.7275 2.61414ZM6.32129 11.9657L8.12305 11.2098L16.0859 3.24695L14.7324 1.90222L6.76953 9.8739L5.97852 11.6141C5.89062 11.8163 6.11914 12.0448 6.32129 11.9657ZM2.98145 17.8632H13.2207C14.9082 17.8632 15.9014 16.8788 15.9014 14.9979V5.71668L14.1436 7.4657V14.8397C14.1436 15.6835 13.6953 16.1053 13.1064 16.1053H3.0957C2.28711 16.1053 1.84766 15.6835 1.84766 14.8397V5.07508C1.84766 4.23133 2.28711 3.80945 3.0957 3.80945H10.5576L12.3066 2.05164H2.98145C1.08301 2.05164 0.0898438 3.03601 0.0898438 4.91687V14.9979C0.0898438 16.8788 1.08301 17.8632 2.98145 17.8632Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'WriteIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
